import { ActionTypes } from "./actions";

const newInitialState = () => ({
    allowedPrompts: null,
});

export const analyzeReducer = (state = newInitialState(), action) => {
    switch (action.type) {
        case ActionTypes.SET_ALLOWED_PROMPTS:
            return {
                ...state,
                allowedPrompts: action.payload,
            };
        default:
            return state;
    }
};
